angular.module('app').config(teamMembersRouting);

function teamMembersRouting($routeProvider) {
  $routeProvider
    .when('/team_members', {
      pageTitle: 'TEAM_MEMBERS',
      template: '<team-members-page></team-members-page>',
      menu: 'contacts',
      accessPermission: 'index_teammember_accountadmin',
      authReq: true,
    })
    .when('/team_members/new', {
      pageTitle: 'ADD_TEAM_MEMBER',
      template: '<team-member-page></team-member-page>',
      breadcrumb: {
        label: 'TEAM_MEMBERS',
        parent: 'team_members',
        ajs: true,
      },
      menu: 'contacts',
      accessPermission: 'create_teammember_accountadmin',
      authReq: true,
    })
    .when('/team_members/:id', {
      params: {
        mode: null,
      },
      pageTitle: 'EDIT_TEAM_MEMBER',
      template: '<team-member-page></team-member-page>',
      breadcrumb: {
        label: 'TEAM_MEMBERS',
        parent: 'team_members',
        ajs: true,
      },
      menu: 'contacts',
      accessPermission: 'show_teammember_accountadmin',
      authReq: true,
    });
}

teamMembersRouting.$inject = ['$routeProvider'];
